function slugifyOpeningName(name: string): string {
  return name
    .toLowerCase()
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/['']/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

function openingFamilyFromName(opening: string): string {
  const trimmed = opening.trim();
  const colonIndex = trimmed.indexOf(':');
  return colonIndex >= 0 ? trimmed.slice(0, colonIndex).trim() : trimmed;
}

function openingVariationSuffix(opening: string): string {
  const trimmed = opening.trim();
  const colonIndex = trimmed.indexOf(':');
  const suffix =
    colonIndex >= 0 ? trimmed.slice(colonIndex + 1).trim() : trimmed;
  return suffix.replace(/ Variation$/i, '').trim();
}

export function openingFamilySlug(opening: string): string {
  return slugifyOpeningName(openingFamilyFromName(opening));
}

export function openingVariationSlug(opening: string): string {
  return slugifyOpeningName(openingVariationSuffix(opening));
}

/** Search queries to try when resolving a family slug back to corpus opening names. */
export function openingFamilySlugToSearchQueries(familySlug: string): string[] {
  const words = familySlug.trim().toLowerCase().split('-').filter(Boolean);
  if (words.length === 0) {
    return [];
  }

  const titled = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1),
  );
  const queries: string[] = [titled.join(' ')];

  for (let hyphenCount = 1; hyphenCount < words.length; hyphenCount += 1) {
    const hyphenPart = titled.slice(0, hyphenCount).join('-');
    const rest = titled.slice(hyphenCount).join(' ');
    queries.push(rest ? `${hyphenPart} ${rest}` : hyphenPart);
  }

  if (words.length > 1) {
    queries.push(titled[0]);
  }

  return [...new Set(queries)];
}

export function playerBrowseSlug(username: string): string {
  return username
    .trim()
    .toLowerCase()
    .replace(/[,\s.]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
